"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tracking", {
  enumerable: true,
  get: function get() {
    return _tracking.default;
  }
});
Object.defineProperty(exports, "AB", {
  enumerable: true,
  get: function get() {
    return _reactReduxAbModules.default;
  }
});
Object.defineProperty(exports, "Num", {
  enumerable: true,
  get: function get() {
    return _num.default;
  }
});
Object.defineProperty(exports, "logger", {
  enumerable: true,
  get: function get() {
    return _logging.default;
  }
});
exports.default = void 0;

var _tracking = _interopRequireDefault(require("./tracking"));

var _reactReduxAbModules = _interopRequireDefault(require("./react-redux-ab-modules"));

var _num = _interopRequireDefault(require("./num"));

var _logging = _interopRequireDefault(require("./logging"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Common module for client side libraries shared across the
 * different node-react apps within NerdWallet.
 *
 * @module
 */

/**
 * Tracking client lib module to enable analytic events on NW's apps.
 *
 * @module
 */

/**
 * AB module to integrate react and redux with internal AB / Optimizely
 *
 * @module
 */
var _default = {
  Tracking: _tracking.default,
  AB: _reactReduxAbModules.default,
  Num: _num.default,
  logger: _logging.default
};
exports.default = _default;